import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export const InternalBackButton = ({ onBack, label = "BACK", testId = "page-back-button", className = "" }) => {
  return (
    <Button
      data-testid={testId}
      onClick={onBack}
      variant="ghost"
      size="sm"
      className={`text-white hover:bg-white/10 px-2 ${className}`.trim()}
    >
      <ArrowLeft className="h-4 w-4 sm:mr-2" />
      <span className="hidden sm:inline">{label}</span>
    </Button>
  );
};

export const InternalPageHeader = ({
  title,
  subtitle,
  onBack,
  actions,
  leading,
  testId = "internal-page-header",
  backTestId = "page-back-button",
}) => {
  return (
    <header className="bg-[#09090b] text-white shadow-lg sticky top-0 z-50" data-testid={testId}>
      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-3 sm:py-4">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 sm:gap-3 min-w-0">
            <InternalBackButton onBack={onBack} testId={backTestId} />
            {leading}
            <div className="min-w-0">
              <h1 className="heading-font text-sm sm:text-2xl tracking-tight whitespace-nowrap">{title}</h1>
              {subtitle && <p className="text-[11px] sm:text-xs text-white/65 mt-0.5 truncate">{subtitle}</p>}
            </div>
          </div>
          {actions ? <div className="flex items-center gap-1 sm:gap-2 shrink-0">{actions}</div> : null}
        </div>
      </div>
    </header>
  );
};